import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { api } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { Lock, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";

const CAT_LABEL = { verbal: "Ragionamento Verbale", abstract: "Ragionamento Astratto", numerical: "Ragionamento Numerico" };

export default function Guides() {
  const [guides, setGuides] = useState([]);
  const { user } = useAuth();
  useEffect(() => { api.get("/guides").then(r => setGuides(r.data)); }, []);

  return (
    <Layout>
      <div className="bg-[#0B1221] text-white premium-grain">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
          <div className="label-mono text-[#FFD700] mb-4">— Guide Premium</div>
          <h1 className="text-5xl lg:text-6xl font-black tracking-tighter mb-4">Metodo, non tentativi.</h1>
          <p className="text-slate-300 max-w-2xl leading-relaxed">Tre guide editoriali (una per ogni tipo di test) che spiegano passo per passo come pensare durante il test EPSO. Contenuto protetto, leggibile online, non scaricabile.</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {guides.map(g => {
            const unlocked = user && ((user.purchases || []).includes(g.required_sku) || user.role === "admin");
            const isAdmin = user?.role === "admin";
            return (
              <div key={g.id} className="border border-slate-200 bg-white p-8 flex flex-col hover:shadow-hard transition-all hover:-translate-y-1">
                <BookOpen className="w-8 h-8 text-[#002FA7] mb-4" strokeWidth={1.5} />
                <div className="label-mono text-slate-500 mb-2">{CAT_LABEL[g.category]}</div>
                <h3 className="font-display font-bold text-xl mb-3">{g.title}</h3>
                <p className="text-sm text-slate-600 flex-1">{g.subtitle}</p>
                <div className="mt-6">
                  {unlocked ? (
                    <Link to={`/guides/${g.id}`}>
                      <Button data-testid={`read-${g.id}`} className="w-full rounded-none bg-[#002FA7] hover:bg-[#001d6b] label-mono py-5">
                        {isAdmin ? "Leggi (anteprima admin)" : "Leggi la guida"}
                      </Button>
                    </Link>
                  ) : (
                    <Link to="/pricing">
                      <Button data-testid={`unlock-guide-${g.id}`} variant="outline" className="w-full rounded-none border-[#002FA7] text-[#002FA7] hover:bg-[#002FA7] hover:text-white label-mono py-5">
                        <Lock className="w-4 h-4 mr-2" />Sblocca la guida
                      </Button>
                    </Link>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
}
